import { storyblokEditable } from "@storyblok/react/rsc";
// import { Badge } from "@workspace/ui/components/badge";
import {
  Card,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@workspace/ui/components/card";
import { DynamicIcon, type IconName } from "lucide-react/dynamic";
import type { TimelineSteps } from "@/types/storyblok";

// biome-ignore lint/suspicious/noRedeclare: TimelineSteps is used for type safety
export default function TimelineSteps({
  blok,
  index,
}: {
  blok: TimelineSteps;
  index: number;
}) {
  return (
    <Card
      className={`${index === 0 && "ring-2 ring-primary border-none"} inset-shadow-2xs inset-shadow-input`}
      // biome-ignore lint/suspicious/noExplicitAny: Required for Storyblok React compatibility
      {...storyblokEditable(blok as any)}
    >
      <CardHeader>
        <div className="flex items-center gap-2">
          <DynamicIcon
            name={blok.icon as IconName}
            className="size-6 text-teal-500"
          />
          <CardTitle className="text-lg font-bold">{blok.title}</CardTitle>
          {/* {blok.badge && blok.badge !== "" && (
            <Badge
              variant="outline"
              className="text-xs ml-auto uppercase font-semibold text-primary bg-primary/10 border-primary/20"
            >
              {blok.badge}
            </Badge>
          )} */}
        </div>
        <CardDescription className="font-medium text-base text-muted-foreground">
          {blok.lead}
        </CardDescription>
      </CardHeader>
    </Card>
  );
}
